import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { CAMPUS_OPTIONS, useCampus } from '../contexts/CampusContext';

const CampusAffiliationModal = () => {
  const {
    campusAffiliation,
    showCampusModal,
    setCampusAffiliation,
    closeCampusModal,
  } = useCampus();

  return (
    <Modal
      show={showCampusModal}
      onHide={campusAffiliation ? closeCampusModal : undefined}
      centered
      backdrop={campusAffiliation ? true : 'static'}
      keyboard={!!campusAffiliation}
      className="campus-modal"
    >
      <Modal.Header closeButton={!!campusAffiliation}>
        <Modal.Title>
          <i className="fas fa-map-marker-alt me-2 text-ut-orange"></i>
          Select Your Campus
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="campus-modal-copy">
          Policy answers will use system-wide policies plus policies for your selected campus,
          or choose All Campuses to search everything at once.
        </p>
        <div className="campus-choice-grid">
          {CAMPUS_OPTIONS.map((campus) => (
            <button
              type="button"
              key={campus.key}
              className={`campus-choice ${campus.key === 'all' ? 'campus-choice-all' : ''} ${campusAffiliation === campus.key ? 'active' : ''}`}
              onClick={() => setCampusAffiliation(campus.key)}
            >
              <span className="campus-choice-icon">
                <i className={`fas ${campus.icon}`}></i>
              </span>
              <span>
                <strong>{campus.label}</strong>
                <small>{campus.shortLabel}</small>
              </span>
            </button>
          ))}
        </div>
      </Modal.Body>
      {campusAffiliation && (
        <Modal.Footer>
          <Button variant="secondary" onClick={closeCampusModal}>
            Close
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default CampusAffiliationModal;
